import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchPrintfulProductVariantsWithSearchCriteria} from "../../services/printful-product-variants-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PRINTFUL_PRODUCT_VARIANTS_FIELDS_LIST} from "../../constants/printful-product-variants.constant";
import {
    getAllPrintfulProducts,
    searchPrintfulProductsWithSearchCriteria
} from "../../services/printful-products-data.service";


const defaultFilterCriteria: any = {};

const PrintfulProductVariantsList = () => {
    const [printfulProductsList, setPrintfulProductsList] = useState(null);
    const [printfulProductVariantsList, setPrintfulProductVariantsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulProductsList = async () => {
        setDataFetchInProgress(true);

        const printfulProductsListResult = await getAllPrintfulProducts();

        setPrintfulProductsList(printfulProductsListResult);
        setPrintfulProductVariantsList(prepareProductVariantsList(printfulProductsListResult));
        // setPrintfulProductsList(_.orderBy(printfulProductsListResult, ['parent_category', 'category', 'title'], ['asc', 'asc', 'asc']));
        setDataFetchInProgress(false);
    }

    const prepareProductVariantsList = (printfulProductsListResult) => {
        const tempPrintfulProductVariantsList = [];

        _.forEach(printfulProductsListResult, (printfulProduct) => {
            _.forEach(printfulProduct.variants, (variant) => {
                variant.productTitle = printfulProduct.title;
                variant.productType = printfulProduct.type;
                variant.productTypeName = printfulProduct.type_name;
                variant.productBrand = printfulProduct.brand;

                tempPrintfulProductVariantsList.push(variant);
            });
        });

        return tempPrintfulProductVariantsList;
    }

    const getPrintfulProductVariantsList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const printfulProductVariantsListResult = await searchPrintfulProductVariantsWithSearchCriteria(searchCriteriaList);

        setPrintfulProductVariantsList(printfulProductVariantsListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulProductsList();
        // await getPrintfulProductVariantsList();
    }, [filterCriteria]);

    const refreshPrintfulProductVariantsList = async () => {
        await getPrintfulProductsList();
        // await getPrintfulProductVariantsList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Printful Product Variants

                        {printfulProductVariantsList &&
                            <span className={'ml-2'}>({printfulProductVariantsList?.length})</span>
                        }
                    </div>

                    {/*<PrintfulProductVariantsFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">

                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulProductVariantsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Product Variants'}/>

                    {printfulProductVariantsList?.length > 0 &&
                        <div className={'table-container overflow-y-scroll border-y border-gray-400 bg-white'}>
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white sticky top-0 w-12">S.No</th>
                                    {PRINTFUL_PRODUCT_VARIANTS_FIELDS_LIST?.map((printfulProductVariantsField, rowIndex) => (
                                        <th key={`th-${rowIndex}`}
                                            className={`p-2 border border-gray-400 bg-gray-400 text-white sticky top-0 text-left pl-2 ${printfulProductVariantsField?.cssClass}`}>{printfulProductVariantsField?.label}</th>
                                    ))}
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white sticky top-0">
                                        Actions
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {printfulProductVariantsList?.map((printfulProductVariants, rowIndex) => (
                                    <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                        <td className="p-2 border border-gray-400 m-auto">
                                            <div className="flex justify-center w-12">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        {PRINTFUL_PRODUCT_VARIANTS_FIELDS_LIST?.map((printfulProductVariantsField, columnIndex) => (
                                            <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                                <td className={`p-2 border border-gray-400 m-auto ${printfulProductVariantsField?.cssClass}`}>
                                                    {printfulProductVariantsField?.optionsMap &&
                                                        <>{printfulProductVariantsField?.optionsMap[printfulProductVariants[printfulProductVariantsField?.attribute]]?.name}</>
                                                    }

                                                    {!printfulProductVariantsField?.optionsMap &&
                                                        <>
                                                            {printfulProductVariants[printfulProductVariantsField?.attribute]}

                                                            {printfulProductVariantsField?.secondaryAttribute &&
                                                                <div className={'text-gray-500 text-sm'}>
                                                                    {printfulProductVariants[printfulProductVariantsField?.secondaryAttribute]}
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        ))}

                                        <td className="p-2 border border-gray-400 m-auto w-40">
                                            <div className="flex justify-center">

                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulProductVariantsList
